var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSignalization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.104 56.379H40.718L36.102 64.379C23.972 64.374 14.104 54.505 14.104 42.375C14.104 30.245 23.972 20.376 36.102 20.375C36.104 20.375 40.718 28.371 40.718 28.371H36.104C28.384 28.375 22.104 34.655 22.104 42.375C22.104 50.095 28.384 56.375 36.104 56.379ZM28.547 69.454H32.807L28.191 77.454C27.486 77.45 26.595 77.23 25.971 77.047C10.682 72.562 0 58.285 0 42.331C0 26.377 10.682 12.099 25.978 7.61201C26.849 7.35601 27.869 7.30001 28.191 7.30001C28.193 7.30001 32.807 15.296 32.807 15.296H28.193C28.193 15.3 28.322 15.297 28.322 15.297C28.279 15.299 28.209 15.305 28.139 15.316C16.277 18.839 8 29.935 8 42.331C8 54.758 16.319 65.878 28.229 69.373C28.325 69.4 28.439 69.429 28.547 69.454ZM28.193 69.45C28.193 69.454 28.397 69.454 28.397 69.454C28.313 69.45 28.243 69.45 28.193 69.45ZM85.289 38.432C83.409 38.432 81.782 39.742 81.381 41.578L80.373 46.194L74.563 9.70401C74.254 7.76301 72.582 6.33401 70.616 6.33301C68.649 6.33301 66.975 7.75901 66.664 9.69801L58.514 60.385L55.708 41.834C55.412 39.878 53.731 38.432 51.753 38.432H41.748C40.483 36.622 38.387 35.436 36.011 35.436C32.145 35.436 29.011 38.57 29.011 42.436C29.011 46.302 32.145 49.436 36.011 49.436C38.39 49.436 40.489 48.246 41.754 46.432H48.312L54.437 86.932C54.732 88.88 56.403 90.325 58.374 90.333C60.355 90.333 62.03 88.908 62.342 86.968L70.594 35.651L75.807 68.393C76.11 70.292 77.72 71.707 79.643 71.762C81.615 71.833 83.255 70.495 83.665 68.617L88.51 46.431H96.012V38.431L85.289 38.432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSignalization);
export default __webpack_public_path__ + "static/media/ico-signalization.a4169c46fdf9e835e66b818b839b15e0.svg";
export { ForwardRef as ReactComponent };